import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import {
    getOptionsObject,
    getOptionsObjectWithApiKey,
    getPlanNumber,
    getRpsDistroAppApiKey
} from '../../utils/api';
import {
  FETCH_VIDEO_URL,
  fetchVideoUrlSuccess,
  fetchVideoUrlError,
  FETCH_FINANCIAL_WELLNESS_TILES,
  fetchFinancialWellnessTilesSuccess,
  fetchFinancialWellnessTilesError,
  FETCH_NAVIGATION_OPTIONS,
  fetchNavigationOptionsSuccess,
  fetchNavigationOptionsError,
  fetchTilesInformationSuccess,
  fetchTilesInformationError,
  FETCH_DISTRO_TILES_INFORMATION,
  fetchDistroTilesInformationSuccess,
  fetchDistroTilesInformationError,
} from './actions';

export const fetchEducationVideosEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_VIDEO_URL),
    flatMap(() =>
      ajax(getOptionsObject('/retirement-income-ui/service/ri-education-video'))
        .pipe(map((res: any) => fetchVideoUrlSuccess(res.response)))
        .pipe(catchError(ex => of(fetchVideoUrlError(ex)))),
    ),
  );

export const fetchTilesInformationEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_VIDEO_URL),
    flatMap(() =>
      ajax(getOptionsObject('/retirement-income-ui/service/ri-tiles-information'))
        .pipe(map((res: any) => fetchTilesInformationSuccess(res.response)))
        .pipe(catchError(ex => of(fetchTilesInformationError(ex)))),
    ),
  );

export const fetchFinancialWellnessTilesEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_FINANCIAL_WELLNESS_TILES),
    flatMap(() =>
      ajax(getOptionsObject('/rps/workplace/ui/financial-wellness-tiles'))
        .pipe(map((res: any) => fetchFinancialWellnessTilesSuccess(res.response)))
        .pipe(catchError(ex => of(fetchFinancialWellnessTilesError(ex)))),
    ),
  );

export const fetchNavigationOptionsEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_NAVIGATION_OPTIONS),
    flatMap(() =>
      ajax(getOptionsObject('/rps/workplace/navigation/navigation-options'))
        .pipe(map((res: any) => fetchNavigationOptionsSuccess(res.response)))
        .pipe(catchError(ex => of(fetchNavigationOptionsError(ex)))),
    ),
  );

export const fetchDistroTilesInformationEpic: Epic = action$ =>
    action$.pipe(
        ofType(FETCH_DISTRO_TILES_INFORMATION),
        flatMap(() =>
            ajax(getOptionsObjectWithApiKey('/dist-profile-service/service/profile/distribution-options?planNumber=' + getPlanNumber(), getRpsDistroAppApiKey()))
                .pipe(map((res: any) => fetchDistroTilesInformationSuccess(res.response)))
                .pipe(catchError(ex => of(fetchDistroTilesInformationError(ex)))),
        ),
    );
